<!-- 发布商标 -->
<template>
  <div class="home">
    <h1>基础信息</h1>
    <div class="content1">
      <div class="form">
        <ul>
          <li>
            <h2>商标名称</h2>
            <input v-model="form.trademark" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>出售价格</h2>
            <input v-model="form.price" type="number" placeholder="请输入" />
          </li>
          <li></li>
          <li class="trademark-category">
            <h2>商标类别</h2>
            <div class="category-tags">
              <div
                v-for="item in dropdownOptions.trademark_category"
                :key="item.value"
                class="category-tag"
                :class="{ active: form.trademark_category === item.value }"
                @click="form.trademark_category = item.value"
              >
                {{ item.label }}
              </div>
            </div>
            <!-- <input type="text" placeholder="请输入" /> -->
            <!-- <div class="sort">
              <el-select v-model="form.trademark_category" placeholder="请选择">
                <el-option
                  v-for="item in dropdownOptions.trademark_category"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
          </li>
          <li>
            <h2>申请号</h2>
            <input
              v-model="form.application_number"
              type="number"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>商标状态</h2>
            <div class="sort">
              <el-select v-model="form.trademark_status" placeholder="请选择">
                <el-option
                  v-for="item in dropdownOptions.trademark_status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <!-- <li>
            <h2>商标结构</h2>
            <input
              v-model="form.trademark_structure"
              type="text"
              placeholder="请输入"
            />
          </li> -->
          <li>
            <h2>商标结构</h2>
            <div class="sort">
              <el-select
                v-model="form.trademark_structure"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in dropdownOptions.trademark_structure"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <h2>商标关键词</h2>
            <input v-model="form.keywords" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>商品/服务</h2>
            <input v-model="form.service" type="text" placeholder="请输入" />
          </li>
          <li></li>
          <li>
            <h2>附图</h2>
            <div class="image-upload-container">
              <!-- 上传按钮（默认显示） -->
              <div
                v-if="!form.trademark_image && !localImagePreview"
                class="upload-placeholder"
                @click="triggerImageUpload"
              >
                <img src="../../assets/uploadPictures.png" alt="上传商标图片" />
              </div>

              <!-- 已上传图片预览 -->
              <div v-else class="image-preview">
                <img
                  :src="localImagePreview || form.trademark_image"
                  alt="商标图片"
                />
                <span class="delete-icon" @click="removeImage">×</span>
              </div>

              <input
                type="file"
                ref="imageInput"
                accept="image/*"
                style="display: none"
                @change="handleImageUpload"
              />
            </div>
          </li>
        </ul>
      </div>
      <div class="submit" @click="submitForm" :disabled="uploading">
        {{ uploading ? "提交中..." : "提交" }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  getParams,
  getUploadImage,
  getPublishTrademark,
  getMyTrademarkDetail,
  getUpdateTrademark,
} from "../../api/userApi";
import service from "../../api";
export default {
  data() {
    return {
      isEditMode: false, // 是否是编辑模式
      currentId: "", // 当前编辑的ID
      uploading: false,
      localImagePreview: "", // 新增本地预览变量
      form: {
        trademark: "", // 商标名称
        price: "", // 出售价格
        trademark_category: "", // 商标类别
        application_number: "", // 申请号
        trademark_status: "", // 商标状态
        trademark_structure: "", // 商标结构
        keywords: "", // 商标关键词
        service: "", // 商品/服务
        trademark_image: "", // 商标图片
      },
      trademark_category: "", // 商标类别
      trademark_status: "", // 商标状态
      value: "",
      dropdownOptions: {
        trademark_category: [], // 商标类别选项
        trademark_status: [], // 商标状态选项
        trademark_structure: [], // 商标结构选项
      },
    };
  },
  created() {
    this.fetchDropdownOptions();
    if (this.$route.query.id) {
      this.isEditMode = true;
      this.currentId = this.$route.query.id;
      this.fetchTrademarkDetail();
    }
  },
  methods: {
    getFullImageUrl(url) {
      if (!url) return "";
      // 如果已经是完整URL则直接返回
      if (url.startsWith("http")) return url;
      // 否则拼接基础URL
      const baseURL =
        (service && service.defaults && service.defaults.baseURL) || "";
      const normalizedBaseURL = baseURL.replace(/\/$/, "");
      const normalizedPath = url.startsWith("/") ? url : `/${url}`;
      return normalizedBaseURL + normalizedPath;
    },
    // 获取商标详情
    async fetchTrademarkDetail() {
      try {
        const response = await getMyTrademarkDetail({
          id: this.currentId,
        });
        if (response.code === 1) {
          // 填充表单数据
          const data = response.data;
          this.form = {
            trademark: data.trademark,
            price: data.price,
            trademark_category: data.trademark_category,
            application_number: data.application_number,
            trademark_status: data.trademark_status,
            trademark_structure: data.trademark_structure,
            keywords: data.keywords,
            service: data.service,
            trademark_image: data.images, // 假设图片字段是images
          };
          // 如果有图片，设置预览
          if (data.images) {
            this.localImagePreview = this.getFullImageUrl(data.images);
          }
        }
      } catch (error) {
        console.error("获取商标详情失败:", error);
      }
    },
    // 处理图片上传
    async handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      try {
        this.uploading = true;

        // 1. 先进行本地预览
        const reader = new FileReader();
        reader.onload = (e) => {
          this.localImagePreview = e.target.result;
        };
        reader.readAsDataURL(file);

        // 2. 上传图片到服务器
        const formData = new FormData();
        formData.append("file", file);
        const uploadResponse = await getUploadImage(formData);

        if (uploadResponse.code === 1 && uploadResponse.data) {
          // 3. 保存服务器返回的URL
          this.form.trademark_image = uploadResponse.data.src;
        } else {
          this.$message.error("图片上传失败");
          this.localImagePreview = ""; // 上传失败清除预览
        }
      } catch (error) {
        console.error("图片上传出错:", error);
        this.$message.error("图片上传出错");
        this.localImagePreview = ""; // 出错清除预览
      } finally {
        this.uploading = false;
        event.target.value = "";
      }
    },

    // 删除图片（修正版）
    removeImage() {
      this.form.trademark_image = "";
      this.localImagePreview = "";
    },
    // 提交表单（新增）
    async submitForm() {
      if (this.uploading) return;

      try {
        this.uploading = true;
        console.log(
          "全部的值:",
          this.form.trademark,
          this.form.price,
          this.form.trademark_category,
          this.form.application_number,
          this.form.trademark_status,
          this.form.trademark_structure,
          this.form.keywords,
          this.form.service,
          this.form.trademark_image
        );

        // 验证必填字段
        if (
          !this.form.trademark ||
          !this.form.price ||
          !this.form.trademark_category ||
          !this.form.application_number ||
          !this.form.trademark_status ||
          !this.form.trademark_structure ||
          !this.form.keywords ||
          !this.form.service ||
          !this.form.trademark_image
        ) {
          this.$message.warning("请填写完整商标信息");
          return;
        }

        // 准备表单数据
        const formData = new FormData();
        Object.keys(this.form).forEach((key) => {
          // 处理图片URL（如果已经上传）
          if (key === "trademark_image" && typeof this.form[key] === "string") {
            formData.append("images", this.form[key]);
          } else {
            formData.append(key, this.form[key]);
          }
        });

        let response;
        if (this.isEditMode) {
          // 编辑模式，调用更新接口
          formData.append("id", this.currentId);
          response = await getUpdateTrademark(formData);
        } else {
          // 新增模式，调用发布接口
          response = await getPublishTrademark(formData);
        }

        if (response.code === 1) {
          this.$message.success(
            this.isEditMode ? "商标更新成功" : "商标发布成功"
          );
          this.resetForm();
          if (this.isEditMode) {
            this.$router.push("/memberCenter/my-publications"); // 返回商标列表
          }
        } else {
          this.$message.error(
            response.msg || (this.isEditMode ? "商标更新失败" : "商标发布失败")
          );
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$message.error("提交过程中出错");
      } finally {
        this.uploading = false;
      }
    },

    // 重置表单（新增）
    resetForm() {
      this.form = {
        trademark: "",
        price: "",
        trademark_category: "",
        application_number: "",
        trademark_status: "",
        trademark_structure: "",
        keywords: "",
        service: "",
        trademark_image: "",
      };
      this.localImagePreview = "";
    },
    // 获取下拉选项
    async fetchDropdownOptions() {
      try {
        const response = await getParams();
        if (response.code === 1 && response.data) {
          const data = response.data;

          // 商标类别
          if (data.trademark_category) {
            this.dropdownOptions.trademark_category =
              data.trademark_category.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
          }

          // 商标状态
          if (data.trademark_status) {
            this.dropdownOptions.trademark_status =
              data.trademark_status.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
          }

          // 商标结构
          if (data.trademark_structure) {
            this.dropdownOptions.trademark_structure =
              data.trademark_structure.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
          }
        }
      } catch (error) {
        console.error("获取下拉选项失败:", error);
      }
    },
    // 触发图片上传
    triggerImageUpload() {
      this.$refs.imageInput.click();
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
.image-upload-container {
  position: relative;
  width: 109px;
  height: 109px;

  .upload-placeholder {
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .image-preview {
    position: relative;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #d8d9dc;
      border-radius: 4px;
    }

    .delete-icon {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 20px;
      height: 20px;
      background: #f56c6c;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
      line-height: 1;
      z-index: 1;

      &:hover {
        background: #e64c4c;
      }
    }
  }
}
.home {
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #434343;
    line-height: 28px;
    text-align: left;
    margin-left: 20px;
    margin-top: 20px;
  }
  .content1 {
    margin: 0 35px;
    .form {
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        border-bottom: 1px solid rgba(222, 222, 222, 1);
        padding: 12px 0 32px 0;
        .trademark-category {
          grid-column: span 3; /* 让商标类别占据整行 */
          width: 100%;

          .category-tags {
            display: grid;
            grid-template-columns: repeat(8, 1fr);
            gap: 10px;
            // margin-top: 15px;

            .category-tag {
              // padding: 8px 5px;
              background: #ffffff;
              border: 1px solid #d8d9dc;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
              font-size: 14px;
              color: #434343;
              transition: all 0.3s;
              width: 115px;
              height: 36px;
              box-sizing: border-box;
              line-height: 36px;
              &:hover {
                border-color: #233cac;
                color: #233cac;
              }

              &.active {
                background-color: #233cac;
                color: white;
                border-color: #233cac;
              }
            }
          }
        }
        li {
          // width: 33.3%;
          margin-top: 20px;
          margin-right: 80px;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          // justify-content: flex-start;
          h2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #434343;
            margin-bottom: 15px;
            // text-align: left;
          }
          input {
            width: 259px;
            height: 43px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: none;
            outline: none;
            border: 1px solid #d8d9dc;
            padding-left: 13px;
            box-sizing: border-box;
          }
          input::placeholder {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #b1b1b1;
          }
          img {
            width: 109px;
            height: 109px;
            cursor: pointer;
          }
          .sort {
            ::v-deep .el-input__inner {
              width: 259px;
              height: 43px;
              background: #ffffff;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #d8d9dc;
              padding: 0 13px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
            }
            ::v-deep .el-input__inner::placeholder {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #b1b1b1;
            }
          }
        }
      }
    }
    .submit {
      cursor: pointer;
      width: 83px;
      height: 42px;
      background: #233cac;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      border-radius: 5px;
      margin-top: 117px;
      margin-bottom: 56px;
    }
  }
}
</style>
